<template>
  <div
    id="doctorField"
    v-click-outside="refreshDoctorName"
    class="doctor-select"
  >
    <md-input-container
      id="patientDoctorName"
      v-click-outside="doctorListClickOutsite"
      :class="{ 'md-input-invalid': errors.has('name') }"
    >
      <label>Médico</label>

      <md-input
        id="txtNewDoctor"
        v-model="doctor.name"
        v-validate="validateRequiredDoctorFields"
        maxlength="60"
        type="text"
        placeholder="Médico"
        data-vv-validate-on="none"
        title
        name="doctor.name"
        @change="handleDoctorInputChange()"
        @focus="handleDoctorInputfocus()"
        @keydown.enter.native="focusNextField('txtNewCRM')"
      />

      <span class="md-error">Obrigatório</span>

      <button
        v-if="isDoctorSelected"
        class="doctor-select__close"
        @click="resetInput()"
      >
        <img
          src="/static/images/icon-close.svg"
          alt="icone-fechar"
        >
      </button>
    </md-input-container>

    <!-- Doctor list -->
    <div
      v-if="showDoctorList"
      class="doctor-list"
    >
      <div>
        <h4>Médicos Relacionados</h4>
        <div
          v-for="doctor in filteredArray"
          :key="doctor.id_doctor"
          class="doctor-list__item"
          @click="selectDoctor(doctor)"
        >
          <div class="doctor-list__name">
            {{ doctor.name }}
          </div>
          <div class="doctor-list__crm">
            {{ doctor.crm + "/" + doctor.uf }}
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h4>Outros Médicos</h4>
        <div
          v-for="doctor in filteredArrayOfNotVinculatedDoctors"
          :key="doctor.id_doctor"
          class="doctor-list__item"
          @click="selectDoctor(doctor)"
        >
          <div class="doctor-list__data">
            <div class="doctor-list__name">
              {{ doctor.name }}
            </div>
            <div class="doctor-list__crm">
              {{ doctor.crm + "/" + doctor.uf }}
            </div>
          </div>
          <button
            class="btn-bordered"
            @click="selectDoctor(doctor)"
          >
            Vincular
          </button>
        </div>
      </div>
      <p
        class="doctor-list__new"
        @click="createNewDoctor"
      >
        Cadastrar novo médico
      </p>
    </div>

    <modal
      ref="createNewDoctorModal"
      title="Cadastrar novo médico"
      template="question"
      :icon-enabled="false"
      ref-name="createNewDoctorModal"
      first-button-text="Cancelar"
      second-button-text="Adicionar"
      :second-button-disabled="addEnable"
      class="add-doctor__modal"
      @first-cta="closeDoctorModal()"
      @second-cta="createDoctor()"
    >
      <div class="add-doctor__card">
        <h4 class="title-main">
          Adicionar médico
        </h4>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="50"
            md-flex-medium="50"
            class="add-doctor__input-crm"
          >
            <md-input-container id="doctorCRM">
              <label>CRM*</label>
              <md-input
                id="txtCRM"
                v-model="doctorCRM"
                v-validate="'required'"
                v-mask="'##########'"
                data-vv-validate-on="none"
                name="txtCRM"
                maxlength="10"
                type="text"
                title=""
                placeholder="CRM*"
              />
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="50"
            md-flex-medium="50"
          >
            <md-input-container
              id="doctorUF"
              tabindex="11"
              :class="{
                'md-input-placeholder md-advanced-select': true,
                'md-has-value': doctorUF,
                'md-input-invalid': errors.has('feature'),
              }"
            >
              <label for="txtUF">UF*</label>
              <advanced-select
                id="txtUF"
                v-model="doctorUF"
                v-validate="'required'"
                :options="optionsUF"
                :taggable="false"
                name="txtUF"
                data-vv-validate-on="none"
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="100"
            md-flex-medium="100"
            class="add-doctor__input-name"
          >
            <md-input-container id="doctorName">
              <label>Nome do médico</label>
              <md-input
                id="txtName"
                v-model="doctorName"
                v-validate="'required'"
                data-vv-validate-on="none"
                name="txtName"
                maxlength="60"
                type="text"
                title=""
                :placeholder="isSearchingDoctor"
              />
              <Spinner v-show="loading" />
            </md-input-container>
          </md-layout>
        </md-layout>
      </div>
    </modal>
  </div>
</template>

<script>
import AdvancedSelect from '@/components/common/AdvancedSelect'
import Spinner from '@/components/common/Spinner'
import { clickOutside } from '@/utils/directives'
import fuzzysort from 'fuzzysort'
import strings from '@/strings'
import { mask } from 'vue-the-mask'
import doctorService from '@/api/doctor'
import notify from '@/api/notification'

export default {
  name: 'DoctorSelect',
  components: {
    'advanced-select': AdvancedSelect,
    Spinner
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside,
    mask: mask
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    patientId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    stateOptions: strings.brazilStates,
    doctor: {
      name: '',
      state: '',
      id: ''
    },
    showDoctorList: false,
    isDoctorSelected: false,
    doctorsNotVinculated: [],
    optionsUF: strings.brazilStates,
    doctorName: null,
    doctorCRM: null,
    doctorUF: null,
    addEnable: false,
    isSearchingDoctor: 'Nome do médico',
    loading: false,
    doctorAlreadyExists: false,
    doctorSelected: null
  }),
  computed: {
    filteredArray () {
      if (this.doctor.name) {
        if (this.doctor.name.length > 0) {
          let list = this.list
          list = list.map((item) => {
            item.crm = item.crm.toString()
            return item
          })
          let result = fuzzysort.go(this.doctor.name, list, {
            keys: ['name', 'crm'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.list
      }
    },
    filteredArrayOfNotVinculatedDoctors () {
      if (this.doctor.name) {
        if (this.doctor.name.length > 0) {
          let list = this.doctorsNotVinculated
          list = list.map((item) => {
            item.crm = item.crm.toString()
            return item
          })
          let result = fuzzysort.go(this.doctor.name, list, {
            keys: ['name', 'crm'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.doctorsNotVinculated
      }
    }
  },
  methods: {
    selectDoctor (doctor) {
      this.isDoctorSelected = true
      this.doctor.name = doctor.name
      this.doctor.state = this.stateOptions.filter(
        (state) => state.value === doctor.uf
      )[0]
      this.doctor.id = doctor.crm
      this.$emit('update', this.doctor)
    },
    validateRequiredDoctorFields () {
      return !this.isStringFieldEmpty(this.doctor.name) ||
        !this.isStringFieldEmpty(this.doctor.id) ||
        this.doctor.state
        ? 'required'
        : ''
    },
    validateDoctorCRM () {
      let validationRules = ''
      if (this.validateRequiredDoctorFields) {
        validationRules = 'required|min:4|max:10|numeric'
      }
      return validationRules
    },
    focusNextField (id) {
      document.getElementById(id).focus()
    },
    doctorListClickOutsite () {
      this.showDoctorList = false
    },
    handleDoctorInputfocus () {
      this.showDoctorList = true

      doctorService
        .getDoctors()
        .then((response) => {
          this.doctorsNotVinculated = this.filterDoctorListByReference(
            response.data,
            this.list
          )
        })
    },
    handleDoctorInputChange () {
      this.isDoctorSelected = false
    },
    refreshDoctorName () {
      if (!this.isDoctorSelected) {
        this.resetInput()
      }
    },
    resetInput () {
      this.doctor.name = ''
      this.doctor.state = ''
      this.doctor.id = ''
      this.isDoctorSelected = false
      this.$emit('update', this.doctor)
    },
    createNewDoctor () {
      this.$refs.createNewDoctorModal.open()
    },
    closeDoctorModal () {
      this.$refs.createNewDoctorModal.close()
    },
    filterDoctorListByReference (doctorsList, doctorsVinculated) {
      let newList = []
      newList = doctorsList.filter((doctor) => {
        return !doctorsVinculated.find((doctorVinculated) => {
          return doctorVinculated.id_doctor === doctor.id_doctor
        })
      })
      return newList
    },
    createDoctor () {
      const doctorData = {
        name: this.doctorName,
        crm: this.doctorCRM,
        uf: this.doctorUF.value
      }

      doctorService.createDoctor(doctorData).then((res) => {
        const doctor = res.data
        this.selectDoctor(doctor)
        this.doctorName = ''
        this.doctorCRM = ''
        this.doctorUF = ''
        this.closeDoctorModal()
      })
        .catch(error => {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
          this.resetInput()
          this.$refs.createNewDoctorModal.close()
        })
    }
  }
}
</script>

<style lang="scss">
.doctor-select {
  &__close {
    position: absolute;
    background: transparent;
    right: 5px;
    top: 8px;

    &:hover {
      opacity: 0.9;
    }
  }

  .doctor-list {
    width: 100%;
    position: absolute;
    top: 48px;
    background-color: #fff;
    z-index: 1;
    box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 100%;
    max-height: 276px;
    overflow: auto;
    overflow-x: hidden;

    &__data {
      display: flex;
      justify-content: space-between;
      flex: 1;
      padding-right: 15px;
      align-items: center;
    }

    &__item {
      font-size: 14px;
      color: #4a4a4a;
      line-height: 26px;
      padding: 10px 16px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;

      &:hover {
        background-color: #F4F4F4;
      }

      &--withou-click {
        background-color: #fff;
      }
    }

    &__crm {
      color: #7a7a7a;
    }

    &__new {
      background: rgba(127, 26, 84, 0.05);
      color: #7f1a54;
      padding: 10px 16px;
      cursor: pointer;
      height: 58px;
      display: flex;
      align-items: center;
    }

    hr {
      border: 1px solid #EBEBEB;
    }

    h4 {
      color: #7F1A54;
      text-transform: uppercase;
      line-height: 26px;
      padding: 10px 16px 0;
      font-size: 10px;
      font-weight: 600;
    }

    .btn-bordered {
      padding: 5px 20px;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      color: #7f1a54;
      height: 38px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: .8px;
      background: #fff;

      &:hover {
        background-color: #7f1a54;
        color: #ffffff;
      }
    }
    .advanced-select__container .multiselect__option--selected,
    .advanced-select__container
      .multiselect__option--selected.multiselect__option--highlight {
      background: white;
      font-weight: bold;
      color: black;
    }

    .advanced-select__container .multiselect__option--highlight {
      background: #ddd !important;
      color: black;
    }
  }
}
</style>
